import { withLocale } from 'utils';

const RouterMonitor = ({ children }) => <>{ children }</>;

export default withLocale(RouterMonitor);
